import script from "./VatRatesView.vue?vue&type=script&setup=true&lang=js"
export * from "./VatRatesView.vue?vue&type=script&setup=true&lang=js"

import "./VatRatesView.vue?vue&type=style&index=0&id=09696cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09696cb4"]])

export default __exports__